import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as PolygonSvg } from "../../../components/icon/Polygon2 .svg";
import "./DeleteWidgetPrompt.css";

function DeletePrompt(props: any) {
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [name, setName] = useState("");

  const handlePreviewClose = () => {
    setOpenPreviewDialog(false);
    props.onclose();
  };

  const handlePreviewCloseDelete = () => {
    setOpenPreviewDialog(false);
    props.confirmCallBack(props.dataToBeDeleted, true);
    props.onclose();
  };

  useEffect(() => {
    // console.log("props data: ", props.dataToBeDeleted);
    // console.log("props data: ", props.component);
    // Update name based on the component type and data to be deleted
    if (props.component === "Roles") {
      setName(props.dataToBeDeleted?.data?.roleName || "");
    } else if (props.component === "Groups") {
      setName(props.dataToBeDeleted?.data?.groupName || "");
    } else if (props.component === "Widget") {
      setName(props.dataToBeDeleted?.data?.name || "");
    } else if (props.component === "DataSource") {
      setName(props.dataToBeDeleted?.data?.name || "");
    } else if (props.component === "Query") {
      setName(props.dataToBeDeleted?.data?.name || "");
    } else if (props.component === "TabWidget") {
      const widget = props.dataToBeDeleted?.widget?.widget;


      if (!widget) return;

      const name = widget?.name || "";
      if (widget?.isParent === true) {
        const children = widget?.childWidget || [];
        const childNames = children
          .map((child: any) => child?.name || "")
          .filter((n: string) => n)
          .join(", ");
        setName(
          `${name} is a parent widget. Deleting this will also delete its children: ${childNames || "No children found"}.`
        );
      } else if (widget?.isParent === false) {
        const parentName = widget?.parentWidgetName || "No parent widget available.";
        setName(
          `${name} is a child widget. Deleting this will NOT affect its parent widget: ${parentName}.`
        );
      } else {

        setName(
          `${name} is a standalone widget. Deleting this will not affect or be affected by any parent or child widgets.`
        );
      }
    } else if (props.component === "Tab") {
      setName(props.dataToBeDeleted?.name || "");
    }

    setOpenPreviewDialog(props.open);
  }, [props.component, props.dataToBeDeleted, props.open]);

  return (
    <div>
      <Dialog
        open={props.open}
        keepMounted
        onClose={handlePreviewClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: 'none',
            borderRadius: '8px'
          }
        }}
      >
        <div className="outerDiv">
          <div className="circle">
            <PolygonSvg />
          </div>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="deleteWidget-text">Delete {props.component}</div>
              <div className="warn-text-deletewidget">
                You're going to delete the "{name}" {props.component}.
                <div>Are you sure?</div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <div className="nokeepIt-DeleteWidget-wrapper nokeepIt-DeleteWidget">
              <button className="keep" onClick={handlePreviewClose}>
                No, keep it.
              </button>
            </div>
            <div className="yesDelete-DeleteWidget-wrapper yesDelete-DeleteWidget">
              <button className="confirm" onClick={handlePreviewCloseDelete}>
                Yes, Delete!
              </button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

export default DeletePrompt;
